module.exports = __webpack_public_path__ + "img/success.1c6a31de.png";